import { LicenseManager } from '@ag-grid-enterprise/core'

LicenseManager.setLicenseKey(import.meta.env.VITE_APP_AG_GRID_TABLE_LICENSE_KEY)
